const QueueItem = ({ user, className, onRowClick, user_id }) => {
  if (!user) {
    return <div>User not available</div>;
  }

  // Queue events keep their stable creator ID. EventHandlers resolves that ID
  // against the already-loaded Project directory and supplies the normal name.
  const displayName = user.userName || user.assigned || "Usuario no disponible";
  // The API's parcelReference is the human-readable irrigation number. `parcel`
  // remains as a compatibility fallback for locally cached legacy rows.
  const parcelReference = user.parcela ?? user.parcelReference ?? user.parcel;
  const parcelLabel = parcelReference === null || parcelReference === undefined || parcelReference === ""
    ? "Parcela sin asignar"
    : `Parcela ${parcelReference}`;

  return (
    <li
      className={`${user_id === user.user_id ? "border-green-500 dark:border-green-500 hover:bg-green-200" : "border-gray-200 dark:border-gray-600"} transition-colors border text-gray-700 dark:text-gray-100 gap-x-2 items-center grid grid-cols-[auto_1fr_auto]  rounded-md px-3 py-1 ${className}`}
      onClick={onRowClick ? () => onRowClick(user) : undefined}
      key={user.user_id}
    >
      <span className="font-medium text-right min-w-11">{user.time}</span>
      <span className={`${user_id === user.user_id ? "text-gray-500 dark:text-gray-100" : "text-gray-300"} text-sm`}>{displayName} · {parcelLabel}</span>
      <span>
        {new Date(
          0,
          0,
          0,
          user.duration / 60,
          user.duration % 60
        ).toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
        })}{" "}
        hs
      </span>
    </li>
  );
};

export default QueueItem;
